import { useNavigate } from "react-router-dom"
import { Breadcrumbs, Typography, Box } from "@mui/material"

const BreadcrumbsNav = ({ 
  pageLabel, 
  pageName = null, 
  pageId = null, 
  testCaseName = null, 
  testCaseId = null,
  journey = {},
}) => {
  const navigate = useNavigate()

  const handleNavigate = (path, state) => {
    if (state) {
      navigate(path, state)
    } else {
      navigate(path)
    }
  }

  const breadcrumbMap = {
    "dashboard": [
      { label: "Projects", path: "/" },
      { label: "Dashboard" }
    ],
    "pages": [
      { label: "Projects", path: "/" },
      { label: "Pages" }
    ],
    "prototypes": [
      { label: "Projects", path: "/" },
      { label: "Page Prototypes" }
    ],
    "testCases": [
      { label: "Projects", path: "/" },
      { label: "Test Cases" }
    ],
    "settings": [
      { label: "Projects", path: "/" },
      { label: "Project Settings" }
    ],
    "discovery": [
      { label: "Projects", path: "/" },
      { label: "Pages", path: "/pages" },
      { label: pageName }
    ],
    "journey": [
      { label: "Projects", path: "/" },
      { label: "Test Journeys", path: "/test-journeys" },
      { label: pageName }
    ],
    "journeyTestCase": [
      { label: "Projects", path: "/" },
      { label: "Test Journeys", path: "/test-journeys" },
      { label: journey.name, path: `/test-journey/${journey.id}`},
      { 
        label: `${journey.name} - Test Cases`, 
        path: `/test-journey/${journey.id}`,
        state: { 
          state: {
            activeTab: "testCases" 
          }
        },
      },
      { label: testCaseName }
    ],
    "testCase": [
      { label: "Projects", path: "/" },
      { label: "Pages", path: "/pages" },
      {
        label: pageName,
        path: `/pages/${pageId}`,
        state: {
          state: {
            activeTab: '1'
          }
        }
      },
      {
        label: "Test Cases",
        path: `/pages/${pageId}`,
        state: {
          state: {
            activeTab: '3'
          }
        }
      },
      { label: testCaseName }
    ],
    "testRun": [
      { label: "Projects", path: "/" },
      { label: "Pages", path: "/pages" },
      { label: pageName, path: `/pages/${pageId}` },
      {
        label: "Test Cases",
        path: `/pages/${pageId}`,
        state: {
          state: {
            activeTab: '3'
          }
        }
      },
      {
        label: testCaseName,
        path: `/test-case/${testCaseId}`,
        state: {
          state: {
            activeTab: '1'
          }
        }
      },
      {
        label: "Test Runs",
        path: `/test-case/${testCaseId}`,
        state: {
          state: {
            activeTab: '2'
          }
        }
      },
      { label: `Run Results - ${testCaseName}` }
    ],
    "journeyTestRun": [
      { label: "Projects", path: "/" },
      { label: "Test Journeys", path: "/test-journeys" },
      { label: journey.name, path: `/test-journey/${journey.id}`},
      { 
        label: `${journey.name} - Test Cases`, 
        path: `/test-journey/${journey.id}`,
        state: { 
          state: {
            activeTab: "testCases" 
          }
        },
      },
      {
        label: "Test Runs",
        path: `/test-case/${testCaseId}`,
        state: {
          state: {
            activeTab: '2'
          }
        }
      },
      { label: `Run Results - ${testCaseName}` }
    ]
  }

  const breadcrumbs = breadcrumbMap[pageLabel] || null

  if (!breadcrumbs) return null

  return (
    <Breadcrumbs className="breadcrumbs" separator={<span className="breadcrumbsSeparator">›</span>} aria-label="breadcrumb">
      {breadcrumbs.map((breadcrumb, index) => {
        const isLast = index === breadcrumbs.length - 1
        return isLast ? (
          <Typography key={breadcrumb.label}>
            {breadcrumb.label}
          </Typography>
        ) : (
          <Box
            key={breadcrumb.path}
            className="breadcrumbsLink"
            sx={{ cursor: "pointer", color: "primary.main", "&:hover": { textDecoration: "underline" } }}
            onClick={() => handleNavigate(breadcrumb.path, breadcrumb?.state ? breadcrumb.state : null)}
          >
            <span className="breadcrumbsLink">{breadcrumb.label}</span>
          </Box>
        )
      })}
    </Breadcrumbs>
  )
}

export default BreadcrumbsNav
